(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/assets/react/shared-components/top-menu.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/assets/react/shared-components/top-menu.js');

'use strict';

const {
  TIR_HOME,
  TIR_TERMS,
  TIR_INTEGRITY,
  TIR_RULES
} = svs.termsIntegrity.constants.route;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  Link
} = svs.app.ReactRouter;
const {
  useLocation
} = ReactRouterDOM;
const TopMenu = () => {
  const location = useLocation();
  const branding = svs.core.config.data.svsconfig.site === 'momang' ? 'momang' : 'sport';
  return React.createElement(ItemsMenu, {
    branding: branding,
    centered: true,
    className: "loginItemsMenu"
  }, React.createElement(LinkItem, {
    Component: Link,
    label: "Personuppgifter",
    selected: location.pathname === TIR_INTEGRITY,
    to: TIR_INTEGRITY
  }), React.createElement(LinkItem, {
    Component: Link,
    label: "Villkor",
    selected: location.pathname === TIR_TERMS || location.pathname === TIR_HOME,
    to: TIR_TERMS
  }), React.createElement(LinkItem, {
    Component: Link,
    label: "Spelregler",
    selected: location.pathname === TIR_RULES,
    to: TIR_RULES
  }));
};
svs.termsIntegrity.sharedComponents.TopMenu = TopMenu;

 })(window);